'use strict';

var d3 = require('d3');
var TotalChart = function TotalChart(AbstractChart, scalesService, chartGroups, chartStripes, chartXAxis) {
  var chartParams = require('./TotalParams');
  var chartScales = require('./TotalScales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('value', undefined, false);
    var stripes = chartStripes('data');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    this.render = function (data, range) {
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data);
      this.callForDataGroup([groups, stripes, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
TotalChart.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsStripes', 'ChartElementsXAxis'];
module.exports = TotalChart;